import { FC, memo } from 'react'
import { Button, ButtonProps } from '@chakra-ui/react'

import { Search } from 'components/icons'

type Props = ButtonProps

const ConsultButton: FC<Props> = ({ children, ...props }) => {
  return (
    <Button variant="outline" leftIcon={<Search />} {...props}>
      {children}
    </Button>
  )
}

export default memo(ConsultButton)
